<div class="modal-header border-0 pb-0">
  <h5 class="modal-title fw-bold">{{ modalTitle }}</h5>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="onClose()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="onSave()">
  <div class="modal-body pt-2 pb-1">
    <p class="small text-muted mb-3">* Campos obligatorios</p>
    <div *ngIf="serverMessage" class="alert alert-danger py-2" role="alert">{{ serverMessage }}</div>
    <div class="row g-3">
      <div class="col-md-6">
        <app-cbb-field label="Nombre *" formControlName="nombre" [mensajeError]="fieldError('nombre')"></app-cbb-field>
      </div>
      <div class="col-md-6">
        <app-cbb-field label="Correo *" type="email" formControlName="correo" [mensajeError]="fieldError('correo')"></app-cbb-field>
      </div>
      <div class="col-md-6">
        <cbb-text-field-mask
          label="Teléfono"
          appearance="admin"
          inputClass="cbb-text-field-mask__admin-input"
          placeholder="Celular — Ej: 9 1234 5678"
          mask="0 0000 0000"
          prefix="+56 "
          [value]="form.controls.telefono.value"
          [isInvalid]="!!fieldError('telefono')"
          [mensajeError]="fieldError('telefono')"
          [readonly]="loading"
          (valueOnInput)="onPhoneInput($event)"
          (valueOnBlur)="onPhoneBlur()">
        </cbb-text-field-mask>
      </div>
      <div class="col-md-6">
        <app-cbb-select label="Región *" [options]="regions" bindLabel="nombre" bindValue="codigo" appendTo="body" [clearable]="false" [searchable]="true" formControlName="regionCode" [mensajeError]="fieldError('regionCode')"></app-cbb-select>
      </div>
      <div class="col-12">
        <app-cbb-select
          label="Comunas"
          [options]="communeOptions"
          bindLabel="nombre"
          bindValue="id"
          [multiple]="true"
          [closeOnSelect]="false"
          [clearable]="true"
          [disabled]="!form.controls.regionCode.value || loading"
          [placeholder]="form.controls.regionCode.value ? 'Todas las comunas de la región' : 'Seleccione primero una región'"
          appendTo="body"
          formControlName="comunaIds"
        ></app-cbb-select>
        <p class="ejecutivo-cemento-comuna-help mb-0">
          Si no selecciona comunas, el ejecutivo cubrirá todas las comunas de la región.
        </p>
      </div>
      <div class="col-md-6" *ngIf="isEditMode">
        <app-cbb-select label="Activo" [options]="[{ label: 'Sí', value: true }, { label: 'No', value: false }]" bindLabel="label" bindValue="value" appendTo="body" [clearable]="false" [searchable]="false" formControlName="activo"></app-cbb-select>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 pt-2 d-flex justify-content-end gap-2">
    <app-cbb-button label="Cancelar" color="primary" (action)="onClose()" [disabled]="loading"></app-cbb-button>
    <app-cbb-button [label]="isEditMode ? 'Guardar' : 'Crear'" color="green" type="submit" [disabled]="loading"></app-cbb-button>
  </div>
</form>
